import type { ComponentProps, ReactElement } from 'react'
import { Children } from 'react'

import { Accordion as AccessibleAccordion } from 'react-accessible-accordion'

import { createSharedContext , isArray } from '@twistopayments/design-system/utils'

import type { AccordionItem, AccordionItemProps } from './accordion-item'

export const AccordionLastItemContext = createSharedContext('components/atoms/accordion/accordion#0', false)

type Child = ReactElement<AccordionItemProps, typeof AccordionItem>

type Props = {
  children: Child | Child[]
} & ComponentProps<typeof AccessibleAccordion>

export const Accordion = ({
  children,
  allowZeroExpanded = true,
  ...props
}: Props) => (
  <AccessibleAccordion
    allowZeroExpanded={allowZeroExpanded}
    data-testid="accordion"
    {...props}
  >
    {Children.map<Child, Child>(children, (child, index) =>
      isArray(children) && index < children.length - 1 ? (
        child
      ) : (
        <AccordionLastItemContext.Provider
          key={child.key ?? 'onlyOne'}
          value={true}
        >
          {child}
        </AccordionLastItemContext.Provider>
      )
    )}
  </AccessibleAccordion>
)
